/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LatestPostsApprovedDto } from '../../models/latest-posts-approved-dto';

export interface GetLatestPostsApproved$Params {
}

export function getLatestPostsApproved(http: HttpClient, rootUrl: string, params?: GetLatestPostsApproved$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LatestPostsApprovedDto>>> {
  const rb = new RequestBuilder(rootUrl, getLatestPostsApproved.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LatestPostsApprovedDto>>;
    })
  );
}

getLatestPostsApproved.PATH = '/api/editorial/latest-posts-approved';
